import { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText, Typography } from '@mui/material';

import DeleteIcon from '@mui/icons-material/Delete';
import { OfficeService, getAuthToken } from '../../service';

const OfficeDeleteDialog = ({ officeId, dialogOpen, OnYesClick, OnCancelClick }) => {
    const { instance, accounts } = useMsal();
    const [office, setOffice] = useState();

    useEffect(() => {
        (async () => {
            if (!officeId) return;

            await getOfficeData();
        })();
    }, [officeId]);

    const getOfficeData = async () => {
        const authToken = await getAuthToken(instance, accounts[0]);
        const data = await OfficeService.getById(authToken, officeId);

        if (!data) {
            console.error('Error: Getting Office details.');
            return;
        }

        setOffice(data);
    };

    const handleYesClick = () => {
        OnYesClick();
    };

    const handleCancelClick = () => {
        OnCancelClick();
    };

    return (
        <>
            <Dialog style={{ zIndex: 90 }} open={dialogOpen} scroll={'paper'} maxWidth={'100%'}>
                <DialogTitle id="scroll-dialog-title" scroll={'paper'} style={{ backgroundColor: 'rgb(0, 42, 78)', color: 'rgb(255, 255, 255)' }}>
                    Confirm Office Deletion
                </DialogTitle>
                <DialogContent dividers={true}>
                    <DialogContentText id="alert-dialog-description">Are you sure you want to delete?</DialogContentText>
                    {office && (
                        <center>
                            <Typography>{office.Name}</Typography>
                        </center>
                    )}
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'space-between' }}>
                    <Button onClick={handleCancelClick} variant="outlined">
                        Cancel
                    </Button>
                    <Button onClick={handleYesClick} variant="contained" color={'error'}>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

const OfficeDelete = ({ officeId }) => {
    const [dialogOpen, setDialogOpen] = useState(false);

    const handleDeleteClick = () => {
        setDialogOpen(true);
    };

    const handleDialogCancelClick = () => {
        setDialogOpen(false);
    };

    const handleDialogYesClick = () => {
        // TODO: Add Deletion call here.
        alert('Coming Soon!');
        setDialogOpen(close);
    };

    return (
        <>
            <Button component="label" variant="contained" size="small" color="error" onClick={handleDeleteClick}>
                <DeleteIcon fontSize="small" />
            </Button>
            <OfficeDeleteDialog officeId={officeId} dialogOpen={dialogOpen} OnCancelClick={handleDialogCancelClick} OnYesClick={handleDialogYesClick} />
        </>
    );
};

export default OfficeDelete;
